import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const PartnerpaymentsAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		partnershopid: yup.number().required().label("Partnershopid"),
		paymentreference: yup.string().required().label("Paymentreference"),
		periodstart: yup.string().required().label("Periodstart"),
		periodend: yup.string().required().label("Periodend"),
		totalbookings: yup.number().required().label("Totalbookings"),
		totalamount: yup.number().required().label("Totalamount"),
		commissionamount: yup.number().required().label("Commissionamount"),
		partnerearnings: yup.number().required().label("Partnerearnings"),
		paymentmethod: yup.string().nullable().label("Paymentmethod"),
		status: yup.string().nullable().label("Status"),
		paiddate: yup.string().nullable().label("Paiddate"),
		transactionid: yup.string().nullable().label("Transactionid"),
		notes: yup.string().nullable().label("Notes"),
		createdat: yup.string().nullable().label("Createdat"),
		updatedat: yup.string().nullable().label("Updatedat")
	});
	
	//form default values
	const formDefaultValues = {
		partnershopid: '', 
		paymentreference: '', 
		periodstart: new Date(), 
		periodend: new Date(), 
		totalbookings: '', 
		totalamount: '', 
		commissionamount: '', 
		partnerearnings: '', 
		paymentmethod: '', 
		status: '', 
		paiddate: new Date(), 
		transactionid: '', 
		notes: '', 
		createdat: "(getdate())", 
		updatedat: "(getdate())", 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/partnerpayments`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="PartnerpaymentsAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Partnerpayment"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Partnershopid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="partnershopid"  onChange={formik.handleChange}  value={formik.values.partnershopid}   label="Partnershopid" type="number" placeholder="Enter Partnershopid"  min={0}  step="any"    className={inputClassName(formik?.errors?.partnershopid)} />
                                                <ErrorMessage name="partnershopid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paymentreference *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paymentreference"  onChange={formik.handleChange}  value={formik.values.paymentreference}   label="Paymentreference" type="text" placeholder="Enter Paymentreference"        className={inputClassName(formik?.errors?.paymentreference)} />
                                                <ErrorMessage name="paymentreference" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Periodstart *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="periodstart" value={formik.values.periodstart} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.periodstart)}        />
                                                <ErrorMessage name="periodstart" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Periodend *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="periodend" value={formik.values.periodend} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.periodend)}        />
                                                <ErrorMessage name="periodend" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Totalbookings *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="totalbookings"  onChange={formik.handleChange}  value={formik.values.totalbookings}   label="Totalbookings" type="number" placeholder="Enter Totalbookings"  min={0}  step="any"    className={inputClassName(formik?.errors?.totalbookings)} />
                                                <ErrorMessage name="totalbookings" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Totalamount *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="totalamount"  onChange={formik.handleChange}  value={formik.values.totalamount}   label="Totalamount" type="number" placeholder="Enter Totalamount"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.totalamount)} />
                                                <ErrorMessage name="totalamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Commissionamount *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="commissionamount"  onChange={formik.handleChange}  value={formik.values.commissionamount}   label="Commissionamount" type="number" placeholder="Enter Commissionamount"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.commissionamount)} />
                                                <ErrorMessage name="commissionamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Partnerearnings *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="partnerearnings"  onChange={formik.handleChange}  value={formik.values.partnerearnings}   label="Partnerearnings" type="number" placeholder="Enter Partnerearnings"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.partnerearnings)} />
                                                <ErrorMessage name="partnerearnings" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paymentmethod 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paymentmethod"  onChange={formik.handleChange}  value={formik.values.paymentmethod}   label="Paymentmethod" type="text" placeholder="Enter Paymentmethod"        className={inputClassName(formik?.errors?.paymentmethod)} />
                                                <ErrorMessage name="paymentmethod" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Status 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="status"  onChange={formik.handleChange}  value={formik.values.status}   label="Status" type="text" placeholder="Enter Status"        className={inputClassName(formik?.errors?.status)} />
                                                <ErrorMessage name="status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paiddate 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="paiddate" value={formik.values.paiddate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.paiddate)}        />
                                                <ErrorMessage name="paiddate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Transactionid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="transactionid"  onChange={formik.handleChange}  value={formik.values.transactionid}   label="Transactionid" type="text" placeholder="Enter Transactionid"        className={inputClassName(formik?.errors?.transactionid)} />
                                                <ErrorMessage name="transactionid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Notes 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="notes"  onChange={formik.handleChange}  value={formik.values.notes}   label="Notes" type="text" placeholder="Enter Notes"        className={inputClassName(formik?.errors?.notes)} />
                                                <ErrorMessage name="notes" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="createdat" value={formik.values.createdat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.createdat)}        />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Updatedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="updatedat" value={formik.values.updatedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.updatedat)}        />
                                                <ErrorMessage name="updatedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
PartnerpaymentsAddPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'partnerpayments',
	apiPath: 'partnerpayments/add',
	routeName: 'partnerpaymentsadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default PartnerpaymentsAddPage;
